'use strict';
import * as progress from './progress';
import { initModules } from '../helpers/utilities';
var miniCartOpen = false;
var lastContainerClicked = null;
var lastVideoElement = null;
var videoPaused = false;
var cacheStorage = {};
import modules from '../helpers/modules';

// open the product overlay
function openOverlay(shopLookOverlay, overlayBackground, container) {
    if (shopLookOverlay && overlayBackground) {
        var overlayContent = shopLookOverlay.find('.shop-look-overlay-content');
        var overlayHeading = shopLookOverlay.find('.shop-look-overlay-heading');
        var containerID = container.attr('id');
        var shopClass = container.attr('data-attr');
        overlayHeading.html(container.attr('data-title'));
        shopLookOverlay.removeClass('left right');
        shopLookOverlay.addClass(shopClass);
        shopLookOverlay.addClass('open');
        overlayBackground.addClass('open');
        $('body').css('overflow', 'hidden');
        if (miniCartOpen) {
            return;
        }
        if (containerID in cacheStorage) {
            overlayContent.html(cacheStorage[containerID]);
            initModules();
            return;
        }
        overlayContent.html('');
        progress.showLoader(shopLookOverlay.get(0));
        renderFeaturedProducts(overlayContent, container, containerID);
    }
}

// close the product overlay
function closeOverlay(shopLookOverlay, overlayBackground) {
    if (shopLookOverlay && overlayBackground) {
        shopLookOverlay.removeClass('open');
        overlayBackground.removeClass('open');
        $('body').css('overflow', '');
        miniCartOpen = false;
    }
}

function toggleDeactive(container) {
    if (container.hasClass('active')) {
        container.removeClass('active');
    }
}

function renderFeaturedProducts(overlayContent, container, id) {
    if (!container || container.length === 0) {
        return;
    }
    var URL = container.attr('data-url');
    var isMobile = $(window).width() <= 480 ? true : false;

    $.ajax({
        url: URL,
        type: 'get',
        data: {
            isMobile: isMobile
        },
        success: function success(data) {
            cacheStorage[id] = data;
            overlayContent.html(data);
            initModules();
            progress.hideLoader();
        }
    })
}

function handleShopTheLookClick(videoElement, container, shopLookOverlay, overlayBackground) {
    //Pause video when shop the look button is clicked
    if (videoElement) {
        videoPaused = true;
        lastVideoElement = videoElement.get(0);
        videoElement.get(0).pause();
    }
    dataLayerPush(container);
    openOverlay(shopLookOverlay, overlayBackground, container);
    toggleDeactive(container);
}

// check if element is fully in viewport
function isElementFullyInViewport(element) {
    const clientRect = element[0].getBoundingClientRect();
    return (
        clientRect.top >= 0 &&
        clientRect.left >= 0 &&
        clientRect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        clientRect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function onVisibilityChange(el, callback) {
    var old_visible;
    return function() {
        var visible = isElementFullyInViewport(el);
        if (visible != old_visible) {
            old_visible = visible;
            if (typeof callback == 'function') {
                callback();
            }
        }
    }
}

function dataLayerPush(container) {
    var dataLayerValue = container.attr('data-tracking-value') || '';
    if (dataLayerValue) {
        modules.tracking.init(null, {
            trackEvent: 'shop_the_look',
            trackObject: {
                shop_the_look_title: dataLayerValue
            }
        });
    }
}

// initialize shop the look feature
function initializeShopTheLook() {
    var miniCartIconContainer = $('.minicart-icon-container');
    var shopLookOverlay = $('.shop-look-overlay');
    var overlayBackground = $('.shop-look-overlay-background');
    var shopTheLookOverlayCloseButton = shopLookOverlay ? shopLookOverlay.find('.shop-overlay-close-button') : null;
    var overlayOpened = false;
    if (miniCartIconContainer && miniCartIconContainer.length > 0) {
        miniCartIconContainer.each(function() {
            var container = $(this);
            var shopTheLookButton = container.find('.shop-look-overlay-text');
            var videoElement = container.prev() && container.prev().hasClass('video-asset') ? container.prev() : null;

            if (container && shopTheLookButton) {
                container.on('click', function(event) {
                    lastContainerClicked = event.target
                    overlayOpened = true;
                    handleShopTheLookClick(videoElement, container, shopLookOverlay, overlayBackground);
                });
                shopTheLookButton.on('click', function(event) {
                    // Pause video when shop the look button is clicked
                    lastContainerClicked = event.target.parentElement.parentElement;
                    overlayOpened = true;
                    handleShopTheLookClick(videoElement, container, shopLookOverlay, overlayBackground);
                    event.stopPropagation();
                });
            }

            // close overlay when mini cart is opened
            $('body').on('miniCart:beforeLoad', function() {
                closeOverlay(shopLookOverlay, overlayBackground);
                if (overlayOpened) {
                    miniCartOpen = true;
                }
            });

            // open overlay when mini cart is closed
            $('body').on('miniCart:afterUnLoad', function() {
                if (overlayOpened) {
                    overlayOpened = true;
                    openOverlay(shopLookOverlay, overlayBackground, container);
                }
            });

            if ($(window).width() <= 480) {

                var handler = onVisibilityChange(container, function() {
                    if (container.hasClass('active')) {
                        setTimeout(function() {
                            container.removeClass('active');
                        }, 2000);
                    } else {
                        if (!container.hasClass('active')) {
                            container.addClass('active');
                        }
                        setTimeout(function() {
                            container.removeClass('active');
                        }, 2000);
                    }
                });

                $(window).on('DOMContentLoaded load resize scroll', handler);
                $(container).closest('.module-carousel').on('afterChange', handler);

                $('body').on('product:afterSelectSizeClicked', function() {
                    $('.shop-look-overlay-product-grid > .slick-dots').css('visibility', 'hidden');
                    shopTheLookOverlayCloseButton.hide();
                })

                $('body').on('product:afterQuickShopCloseButtonClicked', function() {
                    $('.shop-look-overlay-product-grid > .slick-dots').css('visibility', 'visible');
                    shopTheLookOverlayCloseButton.show();
                })
            }
        })
    }

    if (shopTheLookOverlayCloseButton) {
        shopTheLookOverlayCloseButton.on('click', function() {
            overlayOpened = false;
            closeOverlay(shopLookOverlay, overlayBackground);
            // Play video when shop the look overlay is closed
            if (videoPaused && lastVideoElement) {
                lastVideoElement.play();
                lastVideoElement = null;
                videoPaused = false;
            }

            // For mobile always expand shop the look button
            if ($(window).width() <= 480) {
                lastContainerClicked.classList.add('active');
                if (miniCartIconContainer.hasClass('active')) {
                    miniCartIconContainer.removeClass('active');
                }
            }
        });
    }

    if (overlayBackground) {
        overlayBackground.on('click', function(event) {
            if (event.target === overlayBackground[0]) {
                overlayOpened = false;
                closeOverlay(shopLookOverlay, overlayBackground);
            }
            // Play video when shop the look overlay is closed
            if (videoPaused && lastVideoElement) {
                lastVideoElement.play();
                lastVideoElement = null;
                videoPaused = false;
            }
        });
    }
}

export default initializeShopTheLook;
